/**
 * dateUtils.js — Local-timezone date utilities.
 *
 * Use these instead of `new Date().toISOString().split('T')[0]` which gives the
 * UTC date, not the local date. Users in UTC-5 after 7pm would see today's task
 * as overdue; users in UTC+9 before 9am wouldn't see today's tasks at all.
 */

/**
 * Returns today's date as 'YYYY-MM-DD' in the user's local timezone.
 * Use this instead of `new Date().toISOString().split('T')[0]` which gives UTC.
 */
export function localToday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Converts any Date object to 'YYYY-MM-DD' in the user's local timezone.
 */
export function localDateStr(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
